<div>
    <h1>Too many failed attempts</h1>
</div>
<div class="icbc-alert-box icbc-alert-box-warning">
    <div>
        <mat-icon class="icbc-alert-icon">error_outline</mat-icon>
    </div>
    <div class="icbc-alert-box-warning-text">
        We're sorry, but we're unable to verify your identity. Your information has not been submitted and has
        not been saved. Please <a href="http://www.icbc.com" target="_blank" class="icbc-link">start over</a>.
    </div>
</div>